<script>
  import Carregando from '~componentes/Carregando.vue';
  
  export default {
    components: {
      Carregando
    },
    data() {
      const anoAtual = new Date().getFullYear();
      const ultimosCincoAnos = Array.from({ length: 5 }, (_, index) => anoAtual - index);

      return {
        carregando: true,
        ultimosCincoAnos,
        anoSelecionado: anoAtual,
      }
    },
    mounted() {
      this.$root.tituloDaPagina = 'Declaração de Rendimentos';

      this.$root.botaoAcaoMostrar = false;
      
      this.carregar();
    },
    methods: {
      gerarIRPF(ano) {
        this.$router.push({
          name: 'pessoa-fisica.irpf.gerar',
          params: { ano },
        });
      },
      carregar() {
        this.carregando = false;
        return;
      },
    }
  }
</script>

<template>
  <div>

    <form @submit.prevent="">

      <carregando v-if="carregando"></carregando>

      <div class="row" v-show="!carregando">
        <div class="col-xs-4">
          <div class="form-group">
            <select id="anoCalendario"
                    class="form-control"
                    v-model="anoSelecionado"
                    v-validate="'required'">
              <option v-for="ano in ultimosCincoAnos" :key="ano" :value="ano">
                {{ ano }} (Ano base {{ ano - 1 }})
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="row" v-show="!carregando">
        <div class="col-xs-12">
          <div class="form-group">
            <button id="gerarIRPF"
                    type="button"
                    class="btn btn-primary"
                    @click="gerarIRPF(anoSelecionado)"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando IRPF...">
              <i class="fa fa-save"></i>
              Gerar Declaração
            </button>
          </div>
        </div>
      </div>

    </form>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/pessoa-fisica/componentes/IRPF.vue